import { t } from 'i18next';
import { resolveFieldLabel } from '../pages/Administration/tabs/LogsTab/helper/resolveFieldLabel';

enum LogType {
  'CREATE',
  'UPDATE',
  'DELETE',
}

function checkLogType(text: string): LogType | undefined {
  if (text.includes('created')) {
    return LogType.CREATE;
  } else if (text.includes('updated')) {
    return LogType.UPDATE;
  } else if (text.includes('deleted')) {
    return LogType.DELETE;
  } else {
    console.warn('Invalid log type');
  }
}

export function translateFieldsInLogsText(text: string, beforeKey = 'the', afterKey = 'fields'): string {
  const logType = checkLogType(text);

  if (logType === LogType.UPDATE) {
    const regex = new RegExp(`${beforeKey}\\s+(.*?)\\s+${afterKey}.*`);

    const match = text.match(regex);

    if (!match) return text;

    const translated = match[1]
      .split(',')
      .map((f) => f.trim())
      // .map((f) => {
      //   const generatedPath = `${translationPath}.${f}`;
      //   const primary = t(generatedPath);

      //   return primary !== generatedPath ? primary : t(`general.${f}`);
      // })
      .map((f) => {
        return resolveFieldLabel(f);
      })
      .join(', ');

    return text.replace(regex, `${translated} ${t('administration.logs.updated')}`);
  } else if (logType === LogType.CREATE) {
    return `${t('administration.logs.created')}`;
  } else {
    return `${t('administration.logs.deleted')}`;
  }
}
